export const gitInfo = {
  "commit": "b13cefa8",
  "commitLong": "b13cefa8f3d6a3828a5a72047ed9457b10d98486",
  "branch": "HEAD",
  "lastCommitTime": "2026-11-04T11:53:44Z"
}